<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.autoLogout.title' | translate }}
    </h4>
    <button class="btn-close" (click)="d('Cross click')" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <p>
      {{ 'components.autoLogout.remainingTime' | translate }}
      <b>{{ formatRemainingTime(secondsRemaining) }}</b>
    </p>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="continueSession()" type="button">
      {{ 'components.autoLogout.continueSession' | translate }}
    </button>
    <button class="secondary" (click)="logOut()" type="button">
      {{ 'components.autoLogout.logOut' | translate }}
      <img src="assets/images/logout-icon.svg" alt="close" />
    </button>
  </div>
</ng-template>
